import { AuthContext } from 'app/context/AuthContext';
import { useContext } from 'react';

export const useProfile = () => {
  const useAuth = () => useContext(AuthContext);
  const { user } = useAuth();
  return user;
};
